module.exports = __webpack_public_path__ + "img/zsjg_common.6967318f.png";